import { PAX_TYPE_INFANT_CODE, PAX_TYPE_ADULT_CODE, PAX_TYPE_YOUNG_ADULT_CODE, PAX_TYPE_CHILD_CODE } from '@ibe.config';
import { INDRAPassengerTypeService } from './passenger-type.indra.service';
import { INDRALanguageMarketService } from './language-market-indra.service';
import { INDRADateService } from './date.indra.service';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import * as i0 from "@angular/core";
import * as i1 from "./passenger-type.indra.service";
import * as i2 from "./language-market-indra.service";
import * as i3 from "./date.indra.service";
var moment = extendMoment(Moment);
var INDRADateValidtyService = /** @class */ (function () {
    function INDRADateValidtyService(passengerTypeService, languageMarketService, dateService) {
        this.passengerTypeService = passengerTypeService;
        this.languageMarketService = languageMarketService;
        this.dateService = dateService;
    }
    INDRADateValidtyService.prototype.INDRA_checkValidBirthDate = function (paxType, lastDepartureDate, birthDate) {
        var _this = this;
        var mapFn = function (year) { return ({
            text: '' + year,
            value: year
        }); };
        if (paxType) {
            var isUKMarket = this.languageMarketService.isUnitedKingdomMarket;
            var passengerTypeRules = this.passengerTypeService.passengerTypeRules;
            if (passengerTypeRules) {
                var currentYear = lastDepartureDate ? parseInt(moment(lastDepartureDate).format('YYYY'), 10) : new Date().getFullYear();
                var maxYear = void 0;
                var minYear = void 0;
                var maxAge = void 0;
                var minAge = void 0;
                switch (paxType) {
                    case PAX_TYPE_ADULT_CODE:
                        if (isUKMarket) {
                            maxYear = currentYear - +passengerTypeRules.MAX_YTH_AGE;
                        }
                        else {
                            maxYear = currentYear - +passengerTypeRules.MIN_ADT_AGE;
                        }
                        minYear = maxYear - 100;
                        maxAge = currentYear - minYear;
                        minAge = currentYear - maxYear;
                        break;
                    case PAX_TYPE_YOUNG_ADULT_CODE:
                        minYear = currentYear - +passengerTypeRules.MAX_YTH_AGE;
                        maxYear = currentYear - +passengerTypeRules.MIN_YTH_AGE;
                        minAge = passengerTypeRules.MIN_YTH_AGE;
                        maxAge = passengerTypeRules.MAX_YTH_AGE;
                        break;
                    case PAX_TYPE_CHILD_CODE:
                        minYear = currentYear - +passengerTypeRules.MAX_CHD_AGE;
                        maxYear = currentYear - +passengerTypeRules.MIN_CHD_AGE;
                        minAge = passengerTypeRules.MIN_CHD_AGE;
                        maxAge = passengerTypeRules.MAX_CHD_AGE;
                        break;
                    case PAX_TYPE_INFANT_CODE:
                        minYear = currentYear - +passengerTypeRules.MAX_INF_AGE;
                        maxYear = currentYear - +passengerTypeRules.MIN_INF_AGE;
                        minAge = passengerTypeRules.MIN_INF_AGE;
                        maxAge = passengerTypeRules.MAX_INF_AGE;
                        break;
                }
                if (maxYear && minYear) {
                    this.minDate = this.dateService.INDRA_subtract(lastDepartureDate, maxAge, 'years').format('YYYY-MM-DD');
                    this.maxDate = this.dateService.INDRA_subtract(lastDepartureDate, minAge, 'years').format('YYYY-MM-DD');
                    this.years = this.dateService.getArrayOfYears(minYear, maxYear + 1).map(mapFn);
                }
            }
        }
        else {
            this.years = this.dateService.getArrayOfYearsFromNowMinus100Years().map(mapFn);
        }
        var isValidDate = this.years.some(function (year) { return year.value == _this.dateService.getYear(birthDate); }) && birthDate <= this.maxDate && birthDate >= this.minDate;
        return isValidDate;
    };
    INDRADateValidtyService.ngInjectableDef = i0.defineInjectable({ factory: function INDRADateValidtyService_Factory() { return new INDRADateValidtyService(i0.inject(i1.INDRAPassengerTypeService), i0.inject(i2.INDRALanguageMarketService), i0.inject(i3.INDRADateService)); }, token: INDRADateValidtyService, providedIn: "root" });
    return INDRADateValidtyService;
}());
export { INDRADateValidtyService };
